// extracted by mini-css-extract-plugin
export default {"padding":"0","default-padding":"_2myUa","defaultPadding":"_2myUa"};